import { useAppStore } from '@/stores/app'

export const isAuthenticated = (): boolean => {
    const appStore = useAppStore()

    return appStore.isLoggedIn()
}

interface JwtPayload {
    client_slug?: string
    [key: string]: unknown
}

// parseJwt decodes a JWT's payload without verifying its signature — the server is the only
// authority on validity; the client reads non-sensitive claims (here: whether a client has
// been picked) purely to route correctly. Returns null for a malformed token.
export const parseJwt = (token: string): JwtPayload | null => {
    const parts = token.split('.')

    if (parts.length !== 3) {
        return null
    }

    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(atob(base64)) as JwtPayload
    } catch {
        return null
    }
}

// hasClientClaim reports whether the token carries a non-empty client_slug — i.e. the user has
// picked a client, so the data plane is reachable. An identity-only token (post-login,
// pre-pick) returns false, which the router uses to send the user to the client picker.
export const hasClientClaim = (token: string): boolean => {
    const payload = parseJwt(token)

    return !!payload && typeof payload.client_slug === 'string' && payload.client_slug.length > 0
}
